import { jsx as _jsx } from "react/jsx-runtime";
import { ValidationWrapper } from '@skbkontur/react-ui-validations';
import { employeeTids } from '../../constants/tids';
import { DirectoryBox } from '../DirectoryBox';
import { FieldWrapper } from '../FieldWrapper';
export const CitizenshipField = ({ validationInfo, citizenshipItems, onValueChange, required, value, }) => {
    const element = (_jsx(DirectoryBox, { width: 348, value: value || undefined, required: required, items: citizenshipItems, onValueChange: onValueChange, "data-tid": employeeTids.citizenshipCombobox }));
    return (_jsx(FieldWrapper, { label: "\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u0442\u0432\u043E", children: validationInfo === undefined ? (element) : (_jsx(ValidationWrapper, { validationInfo: validationInfo, children: element })) }));
};
